import { mapActions, mapGetters } from 'vuex';

import Contract from '@/models/contract';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import marketSharesBar from '@/components/market/market-shares-bar/market-shares-bar.vue';
import { isMarketSingle } from '@/utils/helpers';

export default {
  components: {
    marketChangePrice,
    marketSharesBar,
  },
  data() {
    return {
      imageLoadError: false,
    };
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    contract: {
      type: Object,
      required: true,
    },
    layout: {
      type: String,
      default: 'grid',
    },
    forceSharesPadding: {
      type: Boolean,
      default: false,
    },
    enableImage: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    contractModel() {
      return new Contract(this.contract);
    },
    isMarketSingle() {
      return isMarketSingle(this.market);
    },
    title() {
      return this.isMarketSingle ? 'Latest Price' : (this.contractModel.contractName || this.contractModel.name);
    },
    classModifier() {
      return {
        'market-contract': true,
        [`market-contract--${this.layout}`]: true,
        'market-contract--with-image': this.shouldShowImage,
      };
    },
    forcePadding() {
      return {
        'market-contract__shares-padding': this.forceSharesPadding && (this.contract.userQuantity < 1),
      };
    },
    showSharesBar() {
      return this.contractModel.userQuantity > 0;
    },
    shouldShowImage() {
      return this.enableImage && this.isLayoutDesktop && this.imageUrl && !this.imageLoadError;
    },
    imageAltText() {
      return this.contractModel.contractName;
    },
    imageUrl() {
      return this.contractModel.imageSmall || this.contractModel.contractImageUrl;
    },
    isDisabled() {
      return (
        (typeof this.contractModel.isOpen !== 'undefined' && !this.contractModel.isOpen) ||
        (typeof this.contractModel.contractIsOpen !== 'undefined' && !this.contractModel.contractIsOpen)
      );
    },
  },
  methods: {
    ...mapActions('trade', ['setTradeOptions']),
    openPurchaseJourney(contractId, operationType, operationValue, defaultTab = null) {
      if (this.isDisabled) return;

      this.setTradeOptions({
        contractId,
        operationType,
        defaultTab,
        operationValue: operationValue !== null ? operationValue : (this.contractModel.mode || 'yes'),
      });

      if (
        this.$router.currentRoute.name === 'market-details' &&
        this.$router.currentRoute.params.marketId === this.market.marketId) {
        return;
      }

      this.$router.push({
        name: 'market-details',
        params: {
          marketId: this.market.marketId,
        },
      });
    },
    onImageLoadError() {
      this.imageLoadError = true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-contract/market-contract.js